import { useQuery } from "@tanstack/react-query";

import { api } from "@/lib/api";
import type { DirectoryMember } from "@/lib/types";

/**
 * Name-only roster of the tenant's active members, readable by every signed-in
 * user (employees included). Use this — not `/admin/members` — whenever a view
 * only needs to turn a user id into a display name (board cards, By-person view),
 * so it works for employees too. Returns a Map keyed by user_id for O(1) lookup.
 */
export function useDirectory() {
  const query = useQuery({
    queryKey: ["directory"],
    queryFn: async () => (await api.get<DirectoryMember[]>("/directory")).data,
    staleTime: 5 * 60_000,
  });
  const members = query.data ?? [];
  const byId = new Map(members.map((m) => [m.user_id, m]));
  return { members, byId, isLoading: query.isLoading };
}

export function initialsOf(name: string) {
  const parts = name.trim().split(/\s+/);
  if (parts.length === 1) return parts[0].slice(0, 2).toUpperCase();
  return (parts[0][0] + parts[parts.length - 1][0]).toUpperCase();
}
